export default "__VITE_ASSET__sbAWO0gSrg5u$C2LWBrwOA__"